/**
 * /onboarding/firm — the FIRM (B2B) onboarding wrapper (route shell).
 *
 * A fresh firm lands here from `/auth/callback` (confirmed email, no tenant).
 * This route USED to be a single name-the-firm screen that provisioned the
 * tenant then redirected to MFA → /admin/dashboard. It is now a GUIDED wrapper:
 *
 *   provision (name the practice) → secure (MFA) → brand → invite team →
 *   /admin/dashboard
 *
 * (It used to also bulk-create client trusts + drop documents onto them here,
 * but under first-class tenancy each client gets its own tenant and is
 * onboarded from the Client Book AFTER setup — so those two steps were
 * dropped from this wizard.)
 *
 * The whole journey lives in `./firm-screen.tsx` and is lazy-loaded via
 * `lazyRouteComponent`, so the setup-step bodies (brand controls, the
 * team-invite rows) leave the entry bundle — `/onboarding/firm` is a
 * deliberate destination, not a first-paint route. Same shell+screen split as
 * the sibling `/onboarding/individual` (`onboarding/individual.tsx`), which
 * keeps the size-limit budget held.
 *
 * Routing is UNCHANGED: this file keeps the `/onboarding/firm` route (the
 * generated `routeTree.gen.ts` imports this module's `Route` export and resolves
 * the component from it), so the route still resolves exactly where it did — no
 * routeTree regeneration needed.
 *
 * NB: this shell deliberately does NOT re-export anything from `./firm-screen` —
 * a static re-export would pull the heavy screen module back into the eager
 * entry bundle, defeating the lazy split. The pure helpers
 * (`firmTrackerPosition` / `firmOuterPhase` / `firmSignupFromUser`) are imported
 * directly from `./firm-screen` by tests instead.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/onboarding/firm')({
  component: lazyRouteComponent(() => import('./firm-screen'), 'OnboardingFirmScreen'),
});
